import React, { ChangeEvent, Component } from 'react';
import { ChartState } from '../../../../redux/reducers/ChartReducer';
import CustomLoading from '../../../custom/CustomLoading';
import { RootState } from '../../../../redux/store';
import { changeChart, changeChartEditorOptions, changeIsUpdate, clearChart } from '../../../../redux/actions/ChartActions';
import { enterComponent, leaveComponent } from '../../../../redux/actions/ComponentActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { SegmentAppearance } from '../../../../domain/chart/editor/Segment';
import { ChartType } from '@trlogic/ui-pack';
import { SegmentItem } from '../../../../domain/chart/ChartDomains';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaCounter from '../../FormicaCounter';
import FormicaColorPalette from '../../../custom/color-palette/FormicaColorPalette';
import LanguageUtil from '../../../../util/LanguageUtil';

class ClusteringAppearance extends Component<Props> {
  render() {
    const {
      segmentItem,
      isBreakdown,
      chart: { chart },
    } = this.props;
    const appearance: SegmentAppearance | null = segmentItem?.segments?.clustering?.appearance || null;
    if (appearance == null) return <CustomLoading />;
    return (
      <div className={`flex flex-col w-full h-full items-start gap-y-4 `}>
        <p className={'text-lg text-primary font-semibold'}>{LanguageUtil.get({ id: 'common.label.appearance', defaultMessage: 'Appearance' })}</p>
        <div className={'w-full'}>
          <label className={'text-sm text-f-black-2'} htmlFor={'appearance-select'}>
            {LanguageUtil.get({ id: 'common.label.name', defaultMessage: 'Name' })}
          </label>
          <FormicaInput
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onChangeAppearanceName(e)}
            id={'appearance-select'}
            value={appearance.name}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.doSomething', defaultMessage: 'Do Something' })}
          />
        </div>
        <div className={'w-full'}>
          <label className={'text-sm text-f-black-2'} htmlFor={'prefix-input'}>
            Prefix
          </label>
          <FormicaInput
            onChange={(e) => this.onChangeAppearancePrefix(e.currentTarget.value)}
            value={appearance.prefix}
            id={'prefix-input'}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.prefix', defaultMessage: 'Prefix' })}
          />
        </div>
        <div className={'w-full'}>
          <label className={'text-sm text-f-black-2'} htmlFor={'suffix-input'}>
            {LanguageUtil.get({ id: 'common.label.suffix', defaultMessage: 'Suffix' })}
          </label>
          <FormicaInput
            onChange={(e) => this.onChangeAppearanceSuffix(e.currentTarget.value)}
            value={appearance.suffix}
            id={'suffix-input'}
            placeholder={LanguageUtil.get({ id: 'common.input.placeholder.suffix', defaultMessage: 'Suffix' })}
          />
        </div>
        <div className={'w-full flex items-center justify-between rounded-md px-2 py-2'}>
          <p className={'text-sm text-f-black-2'}>{LanguageUtil.get({ id: 'common.label.decimals', defaultMessage: 'Decimals' })}</p>
          <FormicaCounter value={appearance.decimal} onChange={this.onChangeDecimalValue} />
        </div>
      </div>
    );
  }
  private onChangeColorPalette = (color: string[]) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    if (segmentItem) {
      segmentItem.colorPalette = color;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearanceName = (e: ChangeEvent<HTMLInputElement>) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const appearance: SegmentAppearance | null = segmentItem?.segments?.clustering?.appearance || null;
    if (segmentItem && appearance) {
      appearance.name = e.currentTarget.value;
      segmentItem.name = e.currentTarget.value;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearancePrefix = (prefix: string) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const appearance: SegmentAppearance | null = segmentItem?.segments?.clustering?.appearance || null;
    if (segmentItem && appearance) {
      appearance.prefix = prefix;
      onChangeSegmentItem(segmentItem);
    }
  };

  private onChangeAppearanceSuffix = (suffix: string) => {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const appearance: SegmentAppearance | null = segmentItem?.segments?.clustering?.appearance || null;
    if (segmentItem && appearance) {
      appearance.suffix = suffix;
      onChangeSegmentItem(segmentItem);
    }
  };
  private onChangeDecimalValue(value: number) {
    const { segmentItem, onChangeSegmentItem } = this.props;
    const appearance: SegmentAppearance | null = segmentItem?.segments?.clustering?.appearance || null;
    if (segmentItem && appearance) {
      appearance.decimal = value;
      onChangeSegmentItem(segmentItem);
    }
  }
}

interface Props extends ReduxProps {
  segmentItem: SegmentItem;
  onChangeSegmentItem: (segmentItem: SegmentItem) => void;
  isBreakdown: boolean;
}

const mapStateToProps = (state: RootState) => ({
  chart: state.chart as ChartState,
});

const mapDispatchToProps = { changeChart, changeChartEditorOptions, changeIsUpdate, enterComponent, leaveComponent, clearChart };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(ClusteringAppearance);
